// Subpath import, not the design-system barrel: this screen is the root
// Suspense fallback, so it lands in the initial chunk and must not pull the
// whole design system in with it.
import { Loader } from '../design-system/Loader';

export function LoadingScreen() {
  return (
    <div
      role="status"
      aria-label="Loading"
      // `h-full` collapsed here: #root's height is content-driven, so a
      // percentage had nothing to resolve against and the loader sat at the
      // top. The viewport minus the host safe area is the box #root actually
      // leaves — same formula RevealScreen uses. min-h, not h, so this only
      // ever grows the box; it stays in normal flow and unmounts with the
      // screen, so nothing rendered afterwards is affected.
      className="flex min-h-[calc(100dvh-var(--page-safe-top)-var(--page-safe-bottom))] items-center justify-center"
    >
      <Loader className="text-white" />
    </div>
  );
}
